import React, { Component, Fragment } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import Selectsearch from "react-select";
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import {  
    allStudents,
    fetchRangePutting,
    deleteRangePutting,
    getRangePutting,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class RangePutting extends Component {
   
    constructor(props) {
       
        super(props);
            this.confirmationDialog = React.createRef();
            this.state = {
                student:'',
                eid:'',
                seldate:'',
                viewdiv:false,              
                adddiv:false,
                editdiv:false,
            };  

        this.onBackSection = this.onBackSection.bind(this);  
        this.deleteForm = this.deleteForm.bind(this);
    }

    UNSAFE_componentWillMount() {
		this.props.allStudents();        
	}    

    selstudent(evt){
        var student=evt.value;
        var startdate="";
        var enddate="";
        this.setState({ 
            viewdiv:false,
            adddiv:false,
            editdiv:false,
            student: student,           
        }); 

        this.props.fetchRangePutting(student, startdate, enddate).then((data) => { 
              
            this.setState({ 
                  viewdiv:true,
            });
   
         }); 
    }   

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
   

    onBackSection(){
        this.setState({ 
            student: '',
            viewdiv:true,
            adddiv:false,
            editdiv:false
        }); 
    }

    editAssessment(gid){
        this.props.getRangePutting(gid).then((data) => {   
            var resdata=data.data;
            this.setState({ 
                eid:resdata[0].grpID,
                seldate:resdata[0].grp_date       
              });


            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            var stid=this.state.student;
            this.props.deleteRangePutting(this.data, stid);
            this.data = ""
        }
    }
        
    
    render() {
        const { match, studentlists, rangeputtinglist, loading } = this.props;       
        const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
        });

        const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "date", label: "DATE" },
            { name: "coach", label: "COACH" },
            { name: "obsert", label: "OBSERVATION" },
            { name: "work", label: "WORK IN PROGRESS" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=rangeputtinglist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.grpID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.grpID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                date: assmntval.cdate,
                coach: assmntval.grp_coachname,
                obsert:assmntval.grp_observation,
                work:assmntval.grp_workinprocess,
                action: ebtn,
                action1:dbtn,
                
                }
        });

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Putting Range Intervention| {AppConfig.appTitle}</title>
                <meta name="description" content="Golf Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.rangeputting" />} match={match} />

                <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard> 
                                <div className="row">                                        
                                    <div className="col-sm-12 col-md-12"> 
                                        <FormGroup>
                                            <Label for="Select">Student *</Label>
                                            <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                        </FormGroup>
                                    </div>
                                      
                                </div>
                            </RctCollapsibleCard>  
                        </div>
                </div>

                {this.state.viewdiv &&                             
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Putting</Button></div>}
                                data={tabledata}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                } 

                {this.state.adddiv && 

                    <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.editdiv && 

                    <UpdateItems onClick={this.onBackSection} data={this.state}/>
                }

                <ConfirmationDialog
                    ref={this.confirmationDialog}
                    onConfirm={(res) => this.deleteDataPermanent(res)}
                    data={'putting'}
                    />
          </div>
       )
    }
 }
 
 const mapStateToProps = ({ mostlyused, rangeputting}) => {
    const { studentlists, loading } = mostlyused;
    const { rangeputtinglist } = rangeputting;
	return { studentlists, rangeputtinglist, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    fetchRangePutting,
    deleteRangePutting,
    getRangePutting,
})(RangePutting); 